import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { ReplaySubject, Subscription } from "rxjs";
import { AdditionalFormData, DocumentTypeProps, FormDataDataType, QuestionFieldConfig, SupplierConfigurationCategoryEnum, SupplierConfigurationPropertiesPayload, SupplierConfigurationPropertiesResponse, SupplierTaxInfo, TaxCountryConfig, TaxIdentifierType, TaxIDType, TaxIdTypeInfo, WithHoldingQuestionResponse, WithHoldingResponse, WithHoldingTaxInfoResponse } from "../../profile/models/tax.model";
import { isNotNullOrUndefined, isNullOrEmpty, validateAllFormFields, isNullOrUndefined } from "../../shared/utils/utils";
import { FieldConfig, OPERATION, SupplierTax1099Box, SupplierTaxIDType, TaxWithHoldingQuestionsEnum } from "../../profile/models/supplier.model";
import { MaskedFieldControl } from "../models/masked-field.model";
import { GeneralSettings } from "../../profile/models/generic.model";
import { I18nService } from "../../shared/services/i18n.service";
import { DocumentTypeInfo, OnboardingDocument } from "../../profile/models/onboarding.model";
import { DocumentsGridComponent } from "../documents/documents-grid/documents-grid.component";
import { SelectAutocompleteComponent } from "../autocomplete/select-autocomplete.component";
import { GetTaxIDTypes } from "../../../app/profile/store/selectors/tax.selectors";
import { select, Store } from "@ngrx/store";
import { SupplierState } from "../../../app/profile/store/state/supplierstate.state";
import { SelectCountries, SelectFieldConfiguration, SelectTax1099Boxes } from "../../../app/profile/store/app.selector";
import { Country } from "../../../app/profile/models/masterdata.model";
import { GetCountryList, GetTax1099Boxes } from "../../../app/profile/store/actions/masterdata.action";
import { TaxService } from "app/profile/services/tax.service";
import { DocumentType } from '../../profile/models/supplier.model';
import * as _ from 'lodash';
import { NgDynamicFormComponent } from "@tesla/ng-dynamic-form";
import { TranslocoService } from '@ngneat/transloco';
import { filter, takeUntil } from 'rxjs/operators';
import { OnboardingDocumentsService } from 'app/profile/services/onboarding-document.service';
import * as FileSaver from 'file-saver';
import { IField } from "app/profile/models/dynamic-form.model";
import { TslAccordion } from "@tesla/ng-tds";
import { DecrementLoaderCount, IncrementLoaderCount } from "app/shared/store/actions";
import { TaxidTypeDisplayComponent } from "./taxid-type-display/taxid-type-display.component";

@Component({
    selector: 'tax-edit',
    templateUrl: './tax-edit.component.html',
    styleUrls: ['./tax-edit.component.scss']
})
export class TaxEditComponent implements OnInit, OnDestroy, OnChanges {

    showUSAFields: boolean = false;
    showVATNumber: boolean = false;
    showTaxTypes: boolean = false;
    showAdditionalTaxTypes: boolean = false;
    documentAdding: boolean = false;
    countryList: Country[];
    /** Form group for all the detail fields of the tax information */
    taxForm: FormGroup;

    //#region Tax Details Form Controls
    countryControl: FormControl;
    taxNameControl: FormControl;
    vatNumberControl: FormControl;
    classificationControl: FormControl;
    classificationTypeControl: FormControl;
    otherCompanyControl: FormControl;
    taxIdTypeControl: FormControl;
    taxIdControl: MaskedFieldControl;
    tax1099Control: FormControl;
    selectedCountry: TaxCountryConfig;
    taxIDtypesByCountry: TaxIdTypeInfo[];

    //  Flags to mask tax id if there's already a value in the system
    isNewRecord: boolean = true;
    taxIDExists: boolean = false;
    last4TaxID: string = '';

    isWorkingWithUSEntity: boolean = false;
    showWithholdingTaxQuestions_US:boolean = false;
    isCurrentEntityUS: boolean = false;

    // FinalTaxIdTypeList
    public finalTaxIdTypeList: TaxIdTypeInfo[] = [];
    public addtionalTaxIdTypeList: TaxIdTypeInfo[] = [];
    public TaxIdTypeVerbiage: string = '';
    showW9Verbiage: boolean = false;
    showW8Verbiage: boolean = false;
    isWithHoldingCallRequired: boolean = true;
    previousSelectedCountry: string = ''
    isWorkingWithJPEntity: boolean = false;
    showTNumberControl: boolean = false;
    isSelectedCountryJP: boolean = false;
    configProperties: SupplierConfigurationPropertiesResponse = null;
    AdditionalMandatoryFormControl: string[] = [];
    AdditionalTaxType: TaxIdentifierType = TaxIdentifierType.AdditionalTaxType;
    OptionalDocuments : OnboardingDocument[] = [];
    onboardingTaxDocuments: FieldConfig[] = [];

    //Dynamic WithHolding Form Schema
    formSchema: any = null;
    formData: any = {};
    skippedControl: string[] = [];
    evalfuncList: string[] = [];
    isWithHoldingFormApplicable: boolean = false;
    isSchemaAvailable: boolean = false;
    toggleLablePosition = 'after';
    isToggleSelected:boolean = false;
    actionName: string = 'Expand All';
    additionalFormDataInfoValue:any = null;
    withHoldingFormToolTip:string = 'Please review the withholding form';
    isFirstTaxCountryChange : boolean = false;
    isWithHoldingFormModified : boolean = false;
    formDataConfigurationList:string[] = [];
    showIndividualOrCorporateQuestion: boolean = false;
    Domestic_Corporate_Ques_Control: FormControl;
    Domestic_Corporate_Ques_Error:boolean = false;
    
    // Translation related changes for Dynamic Form
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    file = {};

    // Dynmaic Schema Form Data Additional Variables
    SelectedTaxCountry: string = null;
    CompanyTypeValue: string = null;

    /** Gets array of the form controls for the USA fields */
    get usaControls(): FormControl[] {
        return [
            this.classificationControl,
            this.taxIdTypeControl,
            this.taxIdControl.fieldControl,
            this.tax1099Control
        ];
    }

    get usaControlsClearValidators(): FormControl[] {
        return [
            this.classificationControl,
            this.classificationTypeControl,
            this.otherCompanyControl,
            this.taxIdTypeControl,
            this.taxIdControl.fieldControl,
            this.tax1099Control
        ];
    }
    //#endregion

    //#region Subscriptions
    classificationChangeSub: Subscription;
    taxIdTypeChangeSub: Subscription;
    classificationTypeChangeSub: Subscription;
    JapanDomesticTaxQuestion_Sub: Subscription;
    //#endregion

    /** Required supplier code to be provided by onboaridng parent component */
    @Input('tsl-supplierCode') supplierCode: string = '';

    /** Collection of supported countries to populate the values of the countries dropdown */
    @Input('tsl-countries') taxCountries: TaxCountryConfig[];

    /** Tax ID types to populate dropdown */
    // @Input('tsl-taxIDTypes') taxIDTypes: TaxIDType[] = [];

    /** Values of the form provided by the parent component */
    @Input('tsl-supplierTax') supplierTax: SupplierTaxInfo;

    /** Determines if the controls should be disabled */
    @Input('tsl-readOnly') readOnly = false;

    /** Determines whether to show or hide the save button */
    @Input('tsl-hideSaveButton') hideSaveBtn: boolean = false;

    /** Determines if the app should hide or display the cancel button */
    @Input('tsl-hideCancelButton') hideCancelButton: boolean = false;

    /** General settings of the application */
    @Input('tsl-generalSettings') settings: GeneralSettings;

    /** Label of save button */
    @Input('tsl-saveButtonText') saveBtnText: string = 'Save';

    /** Label text of the cancel button */
    @Input('tsl-cancelButtonText') cancelBtnText: string = 'Cancel';

    /** Tax document data from document step status */
    @Input('tsl-requiredDocuments') requiredDocuments: OnboardingDocument[];

    /** Tax document data from document step status */
    @Input('tsl-taxDocuments') taxDocuments: DocumentType[];

    @Input('tsl-isReactivation') isReactivation: boolean = false;

    /** enable document section validation based on form modification */
    @Input('tsl-enableDocumentSectionValidationBasedOnFieldModification') enableDocumentSectionValidationBasedOnFieldModification: boolean = false;

    /** Event that will be trigger when the cancel button is click */
    @Output('tsl-onCancel') onCancelEvent: EventEmitter<void> = new EventEmitter<void>();

    /** Event to trigger when the form is submitted with valid data */
    @Output('tsl-onSave') onSubmitEvent: EventEmitter<{ supplierTaxInfo: SupplierTaxInfo }> =
        new EventEmitter<{ supplierTaxInfo: SupplierTaxInfo }>();

    /** Event to trigger when the user submits form with invalid data */
    @Output('tsl-onSaveError') onSubmitErrorEvent: EventEmitter<{ errorMessage: string }> =
        new EventEmitter<{ errorMessage: string }>();

    /** Reference to the documents grid in the template */
    @ViewChild('taxDocumentsGrid', { static: false }) documentsGrid: DocumentsGridComponent;

    /** Reference to the country select-autocomplete component */
    @ViewChild('countryAutocomplete', { static: false }) countryAutocomplete: SelectAutocompleteComponent;

    @ViewChild('withHoldingForm', { static: false }) public withHoldingForm: NgDynamicFormComponent;
    @ViewChild(TslAccordion) accordion: TslAccordion;
    @Input('tsl-taskStatus') currentTaskStatus: string = null;
    

    // Additional Tax ID View Child
    @ViewChild('additionalTaxIdTypesForm', {static : false}) public additionalTaxIdTypesForm : TaxidTypeDisplayComponent;


    subscription: Subscription;
    taxIDTypes: TaxIDType[];
    fieldconfig: FieldConfig[] = [];
    tax1099BoxesList: SupplierTax1099Box[] = []; 

    // Additional Mandatory Documents
    additonalMandatoryDocs: DocumentTypeProps[] = [];
    constructor(
        private formBuilder: FormBuilder,
        private store: Store<SupplierState>,
        private taxService: TaxService,
        private translate: I18nService,
        private translocoService: TranslocoService,
        private onboardingDocumentsService: OnboardingDocumentsService) {
        this.subscription = new Subscription();
        this.store.dispatch(new GetCountryList());
        this.store.dispatch(new GetTax1099Boxes());
        this.subscription.add(this.store.pipe(select(GetTaxIDTypes)).subscribe(x => {
            if (x) {
                this.taxIDTypes = x;
            }
        }))
        this.subscription.add(
            this.store.pipe(select(SelectCountries)).subscribe(res => {
                if (res) {
                    this.countryList = res;
                    this.onCountryChange(false);
                }
            })
        )

        //  Initialize form and controls
        this.countryControl = new FormControl('', [Validators.required, this.countryValidatorWrapper(), this.CountryValidator()]);
        this.taxNameControl = new FormControl('', [Validators.required, Validators.maxLength(100)]);
        this.vatNumberControl = new FormControl('', [Validators.required, Validators.maxLength(20)]);
        this.classificationControl = new FormControl('', [Validators.required]);
        this.classificationTypeControl = new FormControl('', null);
        this.otherCompanyControl = new FormControl('', null);
        this.taxIdTypeControl = new FormControl('');
        this.taxIdControl = new MaskedFieldControl('', null);
        this.tax1099Control = new FormControl('');

        // Qatar WithHolding Controls
        this.Domestic_Corporate_Ques_Control = new FormControl('');

        //  Initialize tax form
        this.taxForm = this.formBuilder.group({
            Country: this.countryControl,
            TaxName: this.taxNameControl,
            VATNumber: this.vatNumberControl,
            Classification: this.classificationControl,
            ClassificationType: this.classificationTypeControl,
            OtherCompany: this.otherCompanyControl,
            TaxIDTypes: this.taxIdTypeControl,
            FederalTaxID: this.taxIdControl.fieldControl,
            Tax1099Box: this.tax1099Control,

            // Qatar WithHolding Questions
            Domestic_Corporate_Ques: this.Domestic_Corporate_Ques_Control,
        });

        //  Subscribe to the event of value changed for the classification control, tax Id and company type
        this.classificationChangeSub = this.classificationControl.valueChanges.subscribe(value => this.onClassificationChange(value));
        this.taxIdTypeChangeSub = this.taxIdTypeControl.valueChanges.subscribe(value => {
            this.taxIdControl.editMode();
            this.onTaxIdTypeChangeV2(value);
        });
        this.classificationTypeChangeSub = this.classificationTypeControl.valueChanges.subscribe(value => this.onClassificationTypeChange(value));
        this.Domestic_Corporate_Ques_Control.valueChanges.subscribe(value => { 
            var currentTaxCountry = this.selectedCountry.abbreviation;
            this.CompanyTypeValue = value;
            if(!isNullOrUndefined(currentTaxCountry))
            {
                if (currentTaxCountry == 'US' && value) {
                    if (value == 'Individual' || value == 'Company') {
                      this.tax1099Control.setValidators(Validators.required);
                    } else {
                      this.tax1099Control.clearValidators();
                    }
                    this.tax1099Control.updateValueAndValidity();
                    this.tax1099Control.markAsDirty();
                }
                else
                {
                    this.tax1099Control.clearValidators();
                    this.tax1099Control.updateValueAndValidity();
                    this.tax1099Control.markAsDirty();
                }

                // Update Tax Id and Document Types
                let field =  'Domestic_Registration_Ques_' + currentTaxCountry;
                this.configureQuestionFieldConfig(field, value);

                // Refresh Form Data
                this.AddAdditionalFormDataInfo(this.additionalFormDataInfoValue);
                this.formSchema = {...this.formSchema};
            } 
        });
    }

    ngOnInit(): void {

        //  Initialize tax form
        this.store.pipe(select(SelectCountries)).subscribe(res => {
            if (res) {
                this.countryList = res;
                this.onCountryChange(false);
            }
        })

        this.store.pipe(select(SelectTax1099Boxes)).subscribe(items => {
            if(items)
            {
                this.tax1099BoxesList = items;
            }
        });

        this.updateTaxControlValues();
        this.taxIdTypeChangeSub = this.taxIdTypeControl.valueChanges.subscribe(value => {
            this.taxIdControl.editMode();
            this.onTaxIdTypeChangeV2(value);
        });

        // Intialize translation so that they can be passed to Dynamic form
        this.initTranslation();
    }

    ngOnDestroy(): void {
        this.classificationChangeSub?.unsubscribe();
        this.taxIdTypeChangeSub?.unsubscribe();
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.supplierTax) {
            this.supplierTax = changes.supplierTax.currentValue;
            //  Reset form when tax info from the parent changes
            this.updateTaxControlValues();
        }

        if (changes.readOnly) {
            //  Enable/Disable controls
            //  Required to use setTimeout due to issue when disabling controls in ngInit
            //  See for more: github.com/angular/angular/issues/22556
            setTimeout(() => this.enableControls(), 500);
        }
    }

    /** Updates values of the tax controls */
    private updateTaxControlValues(resetValue = false) {
        //  Set values
        this.taxNameControl.setValue(this.supplierTax?.TaxName || '', { emitEvent: false });
        this.vatNumberControl.setValue(this.supplierTax?.VATNumber || '', { emitEvent: false });
        this.classificationControl.setValue(this.supplierTax?.Classification || '', { emitEvent: false });
        this.classificationTypeControl.setValue(this.supplierTax?.ClassificationType || '', { emitEvent: false });
        this.otherCompanyControl.setValue(this.supplierTax?.OtherCompany || '', { emitEvent: false });
        this.tax1099Control.setValue(this.supplierTax?.Tax1099Box || '', { emitEvent: false });
        this.taxIdTypeControl.setValue(this.supplierTax?.TaxIDTypes || '', { emitEvent: true });

        // On Classification Change update validators
        if(this.supplierTax?.Classification)
        {
            this.onClassificationChange(this.supplierTax?.Classification , false);
        }

        if (this.supplierTax?.Last4FederalTaxID) {
            this.taxIdControl.setFields(this.supplierTax?.FederalTaxID || '',
                [Validators.required],
                this.supplierTax?.IsNewRecord,
                this.supplierTax?.FederalTaxIDExists,
                this.supplierTax?.Last4FederalTaxID);
        } else {
            if (this.supplierTax?.FederalTaxID) {
                this.taxIdControl.setFields(this.supplierTax?.FederalTaxID || '',
                    [Validators.required],
                    this.supplierTax?.FederalTaxID ? false : true,
                    this.supplierTax?.FederalTaxID ? true : false,
                    this.supplierTax?.FederalTaxID ? this.supplierTax?.FederalTaxID.slice(this.supplierTax?.FederalTaxID.length - 4) : '');
            }
        }

        // Thailand WHT Tax questionaire
        if (this.supplierTax?.WithHoldingResponse !== undefined) {
            this.formData = {};
            // Set WithHolding Control Values
            if (this.supplierTax?.WithHoldingResponse?.length > 0) {
                var withHoldingResponse = _.mapKeys(this.supplierTax?.WithHoldingResponse[0], function (value, key) {
                    return _.upperFirst(key);
                });
                this.supplierTax?.WithHoldingResponse?.forEach(withHoldingResp => {
                    // Make the Object to Uppercase
                    var withHoldingResponseObj = _.mapKeys(withHoldingResp, function (value, key) { return _.upperFirst(key); });
                    if (withHoldingResponseObj?.WithHoldingQuestionResponse?.length > 0) {
                        withHoldingResponseObj?.WithHoldingQuestionResponse?.forEach(withHoldingQues => {
                            // Make the Object to Uppercase
                            var withHoldingResponseQuestionObj = _.mapKeys(withHoldingQues, function (value, key) { return _.upperFirst(key); });
                            this.formData[withHoldingResponseQuestionObj.QuestionIdentifier] = withHoldingResponseQuestionObj.QuestionResponse;
                        });
                    }
                });
                this.formData = _.cloneDeep(this.formData);
            }
        }

        if(resetValue == false)
        {
            //  Tax ID type dropdown is required if user is entering a new tax ID
            this.taxIdTypeControl.setValidators(this.supplierTax?.IsNewRecord ? Validators.required : []);
            this.taxIdTypeControl.updateValueAndValidity({ emitEvent: false });

            //  Set value of country autocomplete
            this.countryAutocomplete?.setValue(this.supplierTax?.TaxCountry || '');
            if (this.supplierTax?.TaxCountry) {
                setTimeout(() => {
                    this.countryAutocomplete?.setValue(this.supplierTax?.TaxCountry)
                    this.onCountryChange(false , true);
                }, 500);
            }

            // Trigger events for change in country and classification to set validators correctly.
            this.onCountryChange(false , true);
            this.onTaxIdTypeChangeV2(this.taxIdTypeControl.value);

            //  Enable/Disable controls
            //  Required to use setTimeout due to issue when disabling controls in ngInit
            //  See for more: github.com/angular/angular/issues/22556
            setTimeout(() => this.enableControls(), 500);
        }
    }

    /** Enables or disables form controls */
    private enableControls() {
        let controls = [
            this.countryControl,
            this.taxNameControl,
            this.vatNumberControl,
            this.classificationControl,
            this.classificationTypeControl,
            this.otherCompanyControl,
            this.taxIdTypeControl,
            this.taxIdControl.fieldControl,
            this.tax1099Control,
        ];

        if (this.readOnly) {
            controls.forEach(control => control.disable({ emitEvent: false }));
        } else {
            controls.forEach(control => control.enable({ emitEvent: false }));
        }
    }

    /** Click envent hanlder of the cancel button */
    onCancel() {
        //  Trigger on cancel event
        this.onCancelEvent.emit();
    }

    /** Submit event handler of the form */
    onSubmit() {
        let skipDocumentValidation = false;
        if (this.enableDocumentSectionValidationBasedOnFieldModification && (this.supplierTax?.IsModified == null || this.supplierTax?.IsModified == false)) {
            skipDocumentValidation = (this.isWithHoldingFormApplicable == true && this.isSchemaAvailable == true ) ? ( !(this.isWithHoldingFormModified) && !(this.taxForm.dirty)) : !(this.taxForm.dirty);

            // If Skip Document Validation is true and if no document asscoiated with the current tax id than we should not skip doc validation
            var currentTaxInfoId = this.supplierTax?.ID?.toString();
            if(!isNullOrUndefined(currentTaxInfoId) && skipDocumentValidation == true)
            {
                if(this.requiredDocuments.some(x => x.AssociatedCategoryLinkId?.includes(currentTaxInfoId)) == false)
                {
                    skipDocumentValidation = false;
                }
            }
        }

        // Tax Form Mark As Touched
        this.taxForm.markAllAsTouched();

        // Dynamic Form
        this.withHoldingForm?.dynamicFormGroup.markAllAsTouched();
        var isDynmaicFormValid = (this.isWithHoldingFormApplicable == true && this.isSchemaAvailable == true) ? this.withHoldingForm?.dynamicFormGroup?.valid : true;

        // Check If AdditionalTaxId Form is valid
        var isAdditionalTaxTypesValid  = (this.showAdditionalTaxTypes) ? this.additionalTaxIdTypesForm.isFormValid() : true;

        if (this.taxForm.valid && (isDynmaicFormValid) && (isAdditionalTaxTypesValid)) {
            //  Check if user has provided documents if required
            if (!skipDocumentValidation && this.requiredDocuments?.length > 0) {
                this.documentsGrid.isValid().subscribe((val) => {
                    if (val === true) {
                        this.processSubmit()
                    } else {
                        this.onSubmitErrorEvent.emit({ errorMessage: 'Tax document is missing' });
                        return
                    }
                });
            }
            else {
                this.processSubmit();
            }

        } else {
            this.onSubmitErrorEvent.emit({ errorMessage: this.translate.get('Tax information is not valid') });
            validateAllFormFields(this.taxForm);

            if (this.documentsGrid) {
                //  Trigger validation to show error messages
                this.documentsGrid.isValid();
            }
        }
    }

    private processSubmit() {
        //  Trigger save event
        let tax = new SupplierTaxInfo();
        if (this.supplierTax?.ID) {
            tax.ID = this.supplierTax.ID;
            tax.Operation = OPERATION.UPDATE;
        } else tax.Operation = OPERATION.CREATE;
        tax.TaxCountry = this.countryAutocomplete?.selectedValue || this.countryControl.value;
        tax.TaxName = this.taxNameControl.value;
        tax.VATNumber = this.vatNumberControl.value ? this.vatNumberControl.value : null;
        tax.TaxIDTypes = this.taxIdTypeControl.value;
        tax.FederalTaxID = this.taxIdControl.fieldControl.value;
        tax.Last4FederalTaxID = this.taxIdControl.last4Value;
        tax.IsNewRecord = this.taxIdControl.isNewRecord;
        tax.FederalTaxIDExists = this.taxIdControl.fieldValueExists;
        tax.Tax1099Box = this.tax1099Control.value;
        tax.Classification = this.classificationControl.value;
        tax.ClassificationType = this.classificationTypeControl.value;
        tax.OtherCompany = this.otherCompanyControl.value;

        if (this.showIndividualOrCorporateQuestion) {
            tax.CompanyType = this.Domestic_Corporate_Ques_Control?.value;
        }

        if (this.showWithholdingTaxQuestions_US) {

            tax.StageID = this.supplierTax?.StageID || null;
            if (this.supplierTax?.IsModified == null || this.supplierTax?.IsModified == false) {
                tax.IsModified = this.taxForm.dirty;
            }
        }
        else {
            tax.WithHoldingSelection = null;
            tax.FileFederalTax = null;
            tax.EntityType = null;
        }

        // AppendWithHoldingQuestion
        tax.WithHoldingResponse = [];

        if(this.isWithHoldingFormApplicable == true)
        {
            var finalWithHoldingResponse = this.CreateDynmaicWithHoldingResponse();
            finalWithHoldingResponse?.forEach(x => {
                tax.WithHoldingResponse?.push(x);
            });
        }

        // Filter Documents that does not have an dms Id associated with it
        let taxDocuments = this.documentsGrid && this.documentsGrid.documents ? this.documentsGrid.documents.map(doc => ({ ...doc, FormGroup: null })) : [];
        taxDocuments = taxDocuments.filter(x => !isNullOrUndefined(x.DocumentID) && !isNullOrEmpty(x.DocumentID));

        var filteredRequiredDocuments = [];
        this.requiredDocuments.forEach(doc => {
            if(!isNullOrUndefined(doc.IsOptional) && isNullOrEmpty(doc.IsOptional))
            {
                if(doc?.IsOptional == true && !isNullOrUndefined(doc.DocumentID) && !isNullOrEmpty(doc.DocumentID))
                {
                    filteredRequiredDocuments.push(doc);
                }

                if(doc.IsOptional == false)
                {
                    filteredRequiredDocuments.push(doc);
                }
            }
            else
            {
                filteredRequiredDocuments.push(doc);
            }
        })

        let optionalTaxDocuments = this.documentsGrid && this.documentsGrid.optionalDocuments ? this.documentsGrid.optionalDocuments.map(doc => ({ ...doc, FormGroup: null })) : [];
        if(this.OptionalDocuments?.length > 0)
        {
            optionalTaxDocuments.forEach(doc => {
                var document = this.documentsGrid.optionalDocuments.find(d => d.DocumentID === doc.DocumentID);
                if (document && !isNullOrUndefined(document.FormGroup)) {
                    doc.SignedDate = document?.FormGroup?.get('SignedDate')?.value;
                }
            });

            this.OptionalDocuments.forEach(doc => {
                if(!isNullOrUndefined(doc.IsOptional) && isNullOrEmpty(doc.IsOptional))
                {
                    if(doc?.IsOptional == true && !isNullOrUndefined(doc.DocumentID) && !isNullOrEmpty(doc.DocumentID))
                    {
                        filteredRequiredDocuments.push(doc);
                    }
    
                    if(doc.IsOptional == false)
                    {
                        filteredRequiredDocuments.push(doc);
                    }
                }
                else
                {
                    filteredRequiredDocuments.push(doc);
                }
            })
        }

        taxDocuments.forEach(doc => {
            let document = this.documentsGrid.documents.find(d => d.DocumentID === doc.DocumentID);
            if (document && !isNullOrUndefined(document.FormGroup)) {
                doc.SignedDate = document.FormGroup.get('SignedDate').value;
            }
        })
        tax.Documents = (this.OptionalDocuments?.length > 0) ? [...taxDocuments.map(doc => doc.DocumentID),...this.OptionalDocuments.map(doc => doc.DocumentID)] : taxDocuments.map(doc => doc.DocumentID);
        tax.RequiredDocuments =  (filteredRequiredDocuments?.length > 0) ? filteredRequiredDocuments : this.requiredDocuments;
        
        //  Append uploaded documents to tax object
        tax.DocumentInfos = (this.OptionalDocuments?.length > 0) ? [...taxDocuments, ...optionalTaxDocuments] : taxDocuments;
        tax.AdditionalTaxIds = this.additionalTaxIdTypesForm?.getFormData() ?? [];
        

        this.onSubmitEvent.emit({ supplierTaxInfo: tax });
    }

    /** Handler of the change event for the country dropdown */
    onCountryChange(clearValues: boolean = true , skipTaxResponseReset = false) {
        const country = this.countryAutocomplete?.selectedValue;
        this.selectedCountry = this.taxCountries?.find(x => x.abbreviation == country);

        if (!country) {
            this.showUSAFields = false;
            this.showW8Verbiage = false;
            this.showW9Verbiage = false;
            this.showVATNumber = false;
            this.taxIDtypesByCountry = [];
            return;
        }

        // This field will be used for Dynamic Schema Form Data
        // Do not change the variable name or any modification on UI
        // For any change required for this field please make sure the data is correctly in sync with WithHolding Configiuration Data
        this.SelectedTaxCountry = country;
        this.showIndividualOrCorporateQuestion = ["MX", "QA", "CO" , "US", "PH"]?.includes(this.SelectedTaxCountry) ? true : false;

        if (this.showIndividualOrCorporateQuestion == true) {
            this.AdditionalMandatoryFormControl.push('Domestic_Corporate_Ques');

            if (!isNullOrUndefined(this.supplierTax?.CompanyType)) {
                this.Domestic_Corporate_Ques_Control.setValue(this.supplierTax?.CompanyType);
            }
            else {
                this.Domestic_Corporate_Ques_Control.setValue(null);
            }
        }

        if(this.showIndividualOrCorporateQuestion)
        {
            this.Domestic_Corporate_Ques_Control.clearValidators();
            this.Domestic_Corporate_Ques_Control.setValidators(Validators.required);
            this.Domestic_Corporate_Ques_Control.updateValueAndValidity({ emitEvent: false });
        }
        else
        {
            this.Domestic_Corporate_Ques_Control.clearValidators();
            this.Domestic_Corporate_Ques_Control.setValue(null);
            this.Domestic_Corporate_Ques_Control.updateValueAndValidity({ emitEvent: false });
        }

        // Get Unique Value
        this.AdditionalMandatoryFormControl = this.AdditionalMandatoryFormControl.filter((value, index, array) => array.indexOf(value) === index);
        this.CompanyTypeValue = null;

        // Check withholding tax info configuration
        if (this.previousSelectedCountry !== country) {

            this.callOnboaringTaxDocuments(country);

            var skipUSEntityList = "true";

            // If the tax country is changed and tax task is in rejected status than we will clear out the task data
            if(!isNullOrUndefined(this.currentTaskStatus) && this.currentTaskStatus?.toLowerCase() == 'rejected' && !isNullOrUndefined(this.previousSelectedCountry) && this.previousSelectedCountry?.length > 0 )
            {
                this.supplierTax = null;
                this.updateTaxControlValues(true);
                this.requiredDocuments = [];

                // Get key from FormData
                var formDataKeys = Object.keys(this.formData);
                this.formData = Object.keys(this.formData).reduce((result, key) => {
                    if (this.skippedControl.includes(key)) {
                      result[key] = this.formData[key];
                    }
                    return result;
                  }, {});
            }

            this.taxService.getIsWorkingWithEntityVerification(this.supplierCode, country, skipUSEntityList).subscribe(res => {
                if (res !== null && res !== undefined && res.countryList.length > 0) {

                    if(res?.countryList?.includes('US'))
                    {
                        this.isWorkingWithUSEntity = true;
                        this.isCurrentEntityUS = true;
                        this.updateW8W9VerbiageCondition();
                    }

                    this.evalfuncList = res.onChangeEventFunctionInfo;
                    this.formDataConfigurationList = res.formDataFieldConfigurationKeyMap;
                    this.isWithHoldingFormApplicable = true;
                    this.isWithHoldingFormModified = false;
                    this.isSchemaAvailable = (!isNullOrUndefined(res.withHoldingQuestionSchema)&& Object.keys(res?.withHoldingQuestionSchema)?.length > 0) ? true : false
                    this.skippedControl = [];
                    this.additionalFormDataInfoValue = (!isNullOrUndefined(res.additionalFormDataInfo) && res.additionalFormDataInfo?.length > 0) ? res.additionalFormDataInfo : null;
                    this.AddAdditionalFormDataInfo(res.additionalFormDataInfo);

                    // Assign WithHolding Schema
                    // Assign WithHolding Schema
                    if(!isNullOrUndefined(res?.withHoldingQuestionSchema) && Object.keys(res?.withHoldingQuestionSchema)?.length > 0)
                    {
                        var withHoldingFormSchema = {...res.withHoldingQuestionSchema};
                        if(!isNullOrUndefined(this.formData))
                        {
                            withHoldingFormSchema = this.UpdateSchemaOnPreloadedEvent(withHoldingFormSchema);
                        }
                        this.formSchema = withHoldingFormSchema;
                    }
                    else
                    {
                        this.isWithHoldingFormApplicable = false;
                        this.formSchema = null;
                        this.isSchemaAvailable = false;
                    }
                    var withHoldingFormSchema = {...res.withHoldingQuestionSchema};
                    this.formSchema = withHoldingFormSchema;
                    if(!isNullOrUndefined(this.formData))
                    {
                        withHoldingFormSchema = this.UpdateSchemaOnPreloadedEvent(this.formSchema);
                    }
                }
                else {
                    this.isWithHoldingFormApplicable = false;
                    this.isWorkingWithUSEntity = false;
                    this.isCurrentEntityUS = false;
                    this.formSchema = null;
                }

                // Get Unique Value
                this.AdditionalMandatoryFormControl = this.AdditionalMandatoryFormControl.filter((value, index, array) => array.indexOf(value) === index);

                // Reset Tax Id Controls
                this.resetTaxIdControl(res);

                // Reset Validators for Tax Id Control and Vat Number
                this.resetValidators(clearValues);

            });

            this.CallAdditionalConfigurationService(this.supplierCode, null, country, [], clearValues);

            this.previousSelectedCountry = country;
        }
        else {
            this.previousSelectedCountry = country;
        }

        this.showUSAFields = country == "US";
        this.isSelectedCountryJP = country == "JP";


        /*if (this.selectedCountry && this.countryList) {
            var countryObj = this.countryList.find(y => y.abbreviation == this.selectedCountry?.abbreviation);
            this.taxIDtypesByCountry = this.taxIDTypes?.filter(c => c.countryID == countryObj?.countryID);
        }*/

        // Set Withholding Controls
        this.setWithHoldingQuestions(this.selectedCountry?.abbreviation);

        if (this.showUSAFields) {
            this.usaControls.forEach(control => {
                control.setValidators(Validators.required);
                control.updateValueAndValidity({ emitEvent: false });
            });
        } else {
            this.usaControlsClearValidators.forEach(control => {
                if (clearValues)
                    control.setValue('', { emitEvent: false });
                control.clearValidators();
                control.updateValueAndValidity({ emitEvent: false });
            })
        }

        this.resetValidators(clearValues);
    }

    /** Event handler for when the value of the classification radio buttons change */
    onClassificationChange(classification: string, resetValue:boolean = true) {

        //  Update the validators of the fields inside the classification radio buttons
        //  depending on the current selected classification
        switch (classification) {
            case 'L':
                //  ClassificationType is required
                this.classificationTypeControl.setValidators(Validators.required);
                this.classificationTypeControl.updateValueAndValidity({ emitEvent: false });

                //  OtherCompany is not required
                this.otherCompanyControl.setValue('', { emitEvent: false });
                this.otherCompanyControl.clearValidators();
                this.otherCompanyControl.updateValueAndValidity({ emitEvent: false });
                break;

            case 'O':
                //  Other Compnay is required
                this.otherCompanyControl.setValidators(Validators.required);
                this.otherCompanyControl.updateValueAndValidity({ emitEvent: false });

                //  ClassificationType is not required
                this.classificationTypeControl.setValue('', { emitEvent: false });
                this.classificationTypeControl.clearValidators();
                this.classificationTypeControl.updateValueAndValidity({ emitEvent: false });
                break;

            default:
                //  Neither ClassificationType nor Other Company are required
                this.classificationTypeControl.setValue('', { emitEvent: false });
                this.classificationTypeControl.clearValidators();
                this.classificationTypeControl.updateValueAndValidity({ emitEvent: false });

                this.otherCompanyControl.setValue('', { emitEvent: false });
                this.otherCompanyControl.clearValidators();
                this.otherCompanyControl.updateValueAndValidity({ emitEvent: false });
                break;
        }

        //  Update the value of the tax 1099 based on the classification
        switch (classification) {
            case 'I':
            case 'P':
            case 'T':
                //  If classification is either, Individual, Partnership, or Trust
                //  Set tax 1099 to misc-07
                if(resetValue == true)
                {
                    this.tax1099Control.setValue('MISC-07', { emitEvent: false });
                }
                break;

            case 'L':
                //  If classification is LLC, and company type is Partnership
                if (this.classificationTypeControl.value == 'P') {
                    //  Set tax 1099 to misc-07
                    if(resetValue == true)
                    {
                        this.tax1099Control.setValue('MISC-07', { emitEvent: false });
                    }
                }
                break;

            default:
                //  Otherwise, set 1099 to empty striing
                if(resetValue == true)
                {
                    this.tax1099Control.setValue('', { emitEvent: false });
                }
                break;
        }
    }

    /** Event handler for when the value of the company type control changes */
    onClassificationTypeChange(classificationType: string) {
        if (classificationType) {

            if (classificationType == 'P') {

                //  If company type is Partnership
                //  and classification is either Individual, Partnetship, Trurst, or LLC
                let classification = this.classificationControl.value;
                switch (classification) {
                    case 'I':
                    case 'P':
                    case 'T':
                    case 'L':
                        //  Set tax 1099 to misc-07
                        this.tax1099Control.setValue('MISC-07', { emitEvent: false });
                        break;

                    default:
                        //  Otherwise, set 1099 to empty striing
                        this.tax1099Control.setValue('', { emitEvent: false });
                        break;
                }
            } else {
                //  Otherwise, set 1099 to empty striing
                this.tax1099Control.setValue('', { emitEvent: false });
            }
        }
    }

    /** Event handler for when the value of the Tax ID Type dropdown changes */
    onTaxIdTypeChange(idType: string) {
        if (this.taxIdControl.isNewRecord) {
            //  Set format of the tax ID to 99-9999999 for EIN and 999-99-9999 for SSN
            if (idType == 'EIN') {
                this.taxIdControl.fieldControl.setValidators([Validators.required, Validators.pattern('^[0-9][0-9]?-[0-9]{7}$')]);
            } else if (idType == 'SSN') {
                this.taxIdControl.fieldControl.setValidators([Validators.required, Validators.pattern('^[0-9]{3}-[0-9]{2}-[0-9]{4}$')]);
            }
            else if (idType == 'PAN') {
                this.taxIdControl.fieldControl.setValidators([Validators.required, Validators.pattern('^[0-9a-zA-Z]{10}$')]);
            }
            else if (idType == 'TNumber') {
                this.taxIdControl.fieldControl.clearValidators();
                this.taxIdControl.fieldControl.setValidators([this.blockListValidator(this.selectedCountry?.blockList), Validators.pattern(this.selectedCountry.regexPattern)]);
            }
            this.taxIdControl.fieldControl.updateValueAndValidity({ emitEvent: false });
        }
    }

    onTaxIdTypeChangeV2(taxIdType: string) {

        // Set Validation Required as true
        // If Regex Pattern is Not Empty Set Regex Pattern Validation
        // If selectedCountry has blocked list than add blocked list validator
        // this.taxIdControl.fieldControl.updateValueAndValidity({ emitEvent: false });

        var currentTaxIdTypeInfo = this.taxIDtypesByCountry?.filter(x => x.taxIdType == taxIdType)[0];
        var validatorList = [];
        var taxIdTypeValidatorList = [];

        if (!isNullOrUndefined(currentTaxIdTypeInfo)) {
            if (currentTaxIdTypeInfo.taxIdTypeValidationInfo?.isRequired == true) {
                validatorList.push(Validators.required);
            }

            if (currentTaxIdTypeInfo.taxIdTypeValidationInfo?.isRequired == false) {
                taxIdTypeValidatorList.push(Validators.required);
            }

            if (!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.regexFormatPattern) && !isNullOrEmpty(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.regexFormatPattern)) {
                validatorList.push(Validators.pattern(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.regexFormatPattern));
            }

            if (!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.minLength) && currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.minLength > 0) {
                validatorList.push(Validators.minLength(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.minLength));
            }

            if (!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.maxLength) && currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.maxLength > 0) {
                validatorList.push(Validators.maxLength(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.maxLength));
            }

            if (currentTaxIdTypeInfo.taxIdTypeValidationInfo?.isBlockedListValidationRequired == true) {
                if (!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo.blockListValidationPattern)) {
                    validatorList.push(this.blockListValidator(currentTaxIdTypeInfo?.taxIdTypeValidationInfo.blockListValidationPattern));
                }
            }

            if (validatorList.length > 0) {
                this.taxIdControl.fieldControl.clearValidators();
                this.taxIdControl.fieldControl.setValidators(validatorList);
                this.taxIdControl.fieldControl.updateValueAndValidity({ emitEvent: false });
            }

            // If Tax Id Type selected and not required to push in the change then Add the validators
            if (taxIdTypeValidatorList.length > 0) {
                this.taxIdTypeControl.clearValidators();
                this.taxIdTypeControl.setValidators(taxIdTypeValidatorList);
                this.taxIdTypeControl.updateValueAndValidity({ emitEvent: false });
            }
        }
    }

    getValidationErrorMessages(displayName: string, control: FormControl) {
        if (control.dirty || control.touched) {
            // Get Current Value
            var currentTaxIdType = this.taxIdTypeControl?.value;
            var currentTaxIdtypeInfo = this.taxIDtypesByCountry?.filter(x => x.taxIdType == currentTaxIdType)[0];

            if (control.hasError('required')) {
                return this.translate.get(displayName) + ' ' + this.translate.get('is required');
            }

            if (!isNullOrUndefined(currentTaxIdtypeInfo)) {
                if (control.hasError('blockedNumber')) {
                    return this.translate.get(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.blockedListError);
                }

                if (control.hasError('blockedNumber')) {
                    return this.translate.get(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.blockedListError);
                }

                if (control.hasError('pattern')) {
                    if (!isNullOrUndefined(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.patternError)) {
                        return this.translate.get(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.patternError);
                    }
                    else {
                        return this.translate.get(displayName) + ' ' + this.translate.get('contains invalid characters');
                    }
                }
            }

            if (control == this.vatNumberControl) {
                if (control.hasError('pattern')) {
                    if (this.selectedCountry && this.selectedCountry.regexPattern != null && this.selectedCountry.validationMessage != null) {
                        return this.translate.get(this.selectedCountry.validationMessage);
                    }
                }
            }
        }
    }

    /** Changes the state of the component to edit the tax id field and not use an existing value  */
    editFederalTaxId() {

        //  Change the state of the mask field of tax id to edit mode
        this.taxIdControl.editMode();

        //  Tax ID Type is now required
        this.taxIdTypeControl.setValue('', { emitEvent: false });
        this.taxIdTypeControl.setValidators(Validators.required);
        this.taxIdTypeControl.updateValueAndValidity({ emitEvent: false });

        //  Update the validators of the tax ID control based on the tax ID type, we can use the change event handler for that
        this.onTaxIdTypeChangeV2(this.taxIdTypeControl.value);
    }

    /** Toggles the state of the component to adding a document */
    toggleAddingDocumentState() {
        this.documentAdding = !this.documentAdding;
    }

    /** Determines if we need to show the text box with the last 4 digits of the tax ID */
    showExistingTaxID(): boolean {
        if (this.taxIDtypesByCountry) {
            if (this.taxIdControl.isNewRecord === false || this.taxIdControl.fieldValueExists === true) {
                return true;
            }
        }
        return false;
    }

    /** Determines if we need to disabled the tax ID type dropdown. If we the user is entering a new Tax ID, then it should be enabled. */
    get isTaxIdTypeDisabled() {
        return this.taxIdControl.isNewRecord === false ? true : false;;
    }


    setWithHoldingQuestions(taxCountry: string) {
        if (taxCountry != "US" && taxCountry != "USA" && this.isWorkingWithUSEntity) {
            this.showWithholdingTaxQuestions_US = true;
        } else {
            this.showWithholdingTaxQuestions_US = false;
        }
        this.updateW8W9VerbiageCondition();
    }

    CountryValidator(): ValidatorFn {
        const CountryError = 'CountrySelected';

        return (): { [key: string]: any } | null => {
            if (this.countryControl?.value) {
                let countryValue = this.countryControl?.value as string;
                let selectedValue = this.countryAutocomplete?.selectedValue
                let countrySelected = this.taxCountries.find(x => x.abbreviation == selectedValue);
                let isValid = countrySelected?.country == countryValue;
                if (isValid) {
                    if (this.countryControl.hasError(CountryError)) {
                        //  Remove Country error from Country control
                        delete this.countryControl.errors[CountryError];
                        this.countryControl.updateValueAndValidity();
                    }
                    return null
                } else {
                    //  Add USState error to the state control
                    this.countryControl?.setErrors({ CountrySelected: true });
                    return { [CountryError]: true };
                }
            }

            return null;
        };
    }

    /** Gets user friendly validation error messages */
    getValidationMessages(displayName: string, control: FormControl) {
        if (control.dirty || control.touched) {
            if (control.hasError('required')) {
                return this.translate.get(displayName) + ' ' + this.translate.get('is required');
            }
            if (control.hasError('blockedNumber')) {
                return this.translate.get('Consecutive or repetitive numbers are not allowed');
            }
            if (control.hasError('startWith')) {
                var startWithChar = ''
                if (control.errors?.startWith?.data != undefined && control.errors?.startWith?.data != undefined) {
                    startWithChar = control.errors?.startWith?.data;
                }
                return (startWithChar == '') ? this.translate.get('Value does not start with correct character.') : `${this.translate.get("Value should start with following character")} - ${startWithChar}.`;
            }
            if (control.hasError('minlength') || control.hasError('maxlength')) {
                return this.translate.get('Size of the input is invalid.');
            } else if (control.hasError('pattern')) {
                if (control === this.taxIdControl.fieldControl) {
                    let taxType = this.taxIdTypeControl.value;
                    if (taxType == "EIN") {
                        return this.translate.get('Format should be 99-9999999');
                    } else if (taxType == "SSN") {
                        return this.translate.get('Format should be 999-99-9999');
                    }
                    else if (taxType == "PAN") {
                        return this.translate.get('Should be of length 10 with only alphanumeric characters');
                    }
                    else if (taxType == "TNumber") {
                        if (this.selectedCountry && this.selectedCountry.regexPattern != null && this.selectedCountry.validationMessage != null) {
                            return this.translate.get(this.selectedCountry.validationMessage);
                        }
                    }
                }
                if (control == this.vatNumberControl) {
                    if (this.selectedCountry && this.selectedCountry.regexPattern != null && this.selectedCountry.validationMessage != null) {
                        return this.translate.get(this.selectedCountry.validationMessage);
                    }
                }
                return this.translate.get(displayName) + ' ' + this.translate.get('contains invalid characters');
            }
        }
    }



    //#region Select-Autocomplete Utilities
    /**
     * We are required to wrap the validator from the autocomplete component because the
     * ViewChild reference is not always populated, which will cause an error if we add the
     * autocomplete validator directly to the form control.
     * In this case, we use a wrapper direclty to the form control that checks if the autocomplete
     * refence is not null.
     * @returns functions that invokes the validator from autocomplete component when component is not null
     */
    countryValidatorWrapper() {
        return (control: AbstractControl) => {
            if (!this.countryAutocomplete)
                return null;

            return this.countryAutocomplete.enteredOptionValidator()(control);
        }
    }
    //#region

    updateW8W9VerbiageCondition() {
        if (this.countryControl.value !== undefined && this.countryControl.value !== '' && this.countryControl.value !== null) {
            this.showW9Verbiage = (this.isCurrentEntityUS && (this.countryControl.value === 'US' || this.countryControl.value === 'USA')) ? true : false;
            this.showW8Verbiage = (this.isCurrentEntityUS && this.countryControl.value != 'US' && this.countryControl.value != 'USA') ? true : false;
        } else {
            this.showW8Verbiage = false;
            this.showW9Verbiage = false;
        }
    }

    /** Custom validator for block list values */
    blockListValidator(blockList: string[]): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            let vatNumber = control.value as string;
            if (vatNumber == null) {
                return null;
            }
            if (blockList && blockList.length > 0) {
                return blockList.some(v => vatNumber.includes(v)) ? { blockedNumber: { value: control.value } } : null;
            }

            //  We ignore validation since there isn't a blocklist number
            return null;
        };
    }

    /** Custom validator for block list values */
    startWithValidation(startWithCharacter: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            let taxIdNumber = control.value as string;
            if (taxIdNumber == undefined || taxIdNumber == null || taxIdNumber == '') {
                return null;
            }
            if (startWithCharacter != null && startWithCharacter != undefined) {
                return !taxIdNumber.startsWith(startWithCharacter) ? { startWith: { value: control.value, data: startWithCharacter } } : null;
            }

            //  We ignore validation since there isn't a blocklist number
            return null;
        };
    }

    resetTaxIdControl(withHoldingResponse: WithHoldingTaxInfoResponse) {
        // Reset Tax Type
        if (this.isWorkingWithJPEntity) {
            this.showTaxTypes = true;
        }
        else {
            this.showTaxTypes = (this.taxIDtypesByCountry?.length > 0 && !this.isWorkingWithJPEntity);
        }

        this.showVATNumber = ((this.selectedCountry) && (!this.showTaxTypes))
    }

    resetTaxIdControlV2(configProperties: SupplierConfigurationPropertiesResponse) {
        if (configProperties?.taxIdTypes != undefined && !isNullOrEmpty(configProperties?.taxIdTypes)) {
            this.showTaxTypes = true;
        }
        else {
            this.showTaxTypes = false;
        }

        if (configProperties?.additionalTaxIdTypes != undefined && !isNullOrEmpty(configProperties?.additionalTaxIdTypes) && configProperties?.additionalTaxIdTypes?.length > 0) {
            this.showAdditionalTaxTypes = true;
        }
        else {
            this.showAdditionalTaxTypes = false;
        }

        this.showVATNumber = ((this.selectedCountry) && (!this.showTaxTypes))
    }

    resetValidators(clearValues: boolean) {
        this.showVATNumber = ((this.selectedCountry) && (!this.showTaxTypes))
        if (this.showTaxTypes) {

            if (this.selectedCountry.abbreviation == 'JP') {
                this.taxIdTypeControl.clearValidators();
                this.taxIdControl.fieldControl.clearValidators();
            }
            else {
                this.taxIdTypeControl.setValidators([Validators.required]);
                this.taxIdControl.fieldControl.setValidators([Validators.required]);
            }

            if (clearValues) {
                this.taxIdTypeControl.setValue('', { emitEvent: false });
                this.taxIdControl.editMode();
            }

            this.taxIdTypeControl.updateValueAndValidity({ emitEvent: false });
            this.taxIdControl.fieldControl.updateValueAndValidity({ emitEvent: false });

        } else {
            if (clearValues) {
                this.taxIdTypeControl.setValue('', { emitEvent: false });
                this.taxIdControl.editMode();
            }

            this.taxIdTypeControl.clearValidators();
            this.taxIdControl.fieldControl.clearValidators();

            this.taxIdTypeControl.updateValueAndValidity({ emitEvent: false });
            this.taxIdControl.fieldControl.updateValueAndValidity({ emitEvent: false });
        }

        if (this.showVATNumber) {
            let validators = [];
            validators.push(Validators.required);
            if (this.selectedCountry && this.selectedCountry.regexPattern != null) {
                validators.push(Validators.pattern(this.selectedCountry.regexPattern));
            } else {
                validators.push(Validators.maxLength(20));
            }
            if (this.selectedCountry && this.selectedCountry.blockList && this.selectedCountry.blockList.length > 0) {
                validators.push(this.blockListValidator(this.selectedCountry.blockList));
            }
            this.vatNumberControl.setValidators(validators);

            this.vatNumberControl.updateValueAndValidity({ emitEvent: false });
        } else {
            this.vatNumberControl.setValue('', { emitEvent: false });
            this.vatNumberControl.clearValidators();
            this.vatNumberControl.updateValueAndValidity({ emitEvent: false });
        }
    }

    resetValidatorsV2(clearValues: boolean) {
        if (this.showVATNumber) {
            let validators = [];
            validators.push(Validators.required);
            if (this.selectedCountry && this.selectedCountry.regexPattern != null) {
                validators.push(Validators.pattern(this.selectedCountry.regexPattern));
            } else {
                validators.push(Validators.maxLength(20));
            }
            if (this.selectedCountry && this.selectedCountry.blockList && this.selectedCountry.blockList.length > 0) {
                validators.push(this.blockListValidator(this.selectedCountry.blockList));
            }
            this.vatNumberControl.setValidators(validators);

            this.vatNumberControl.updateValueAndValidity({ emitEvent: false });
        } else {
            this.vatNumberControl.setValue('', { emitEvent: false });
            this.vatNumberControl.clearValidators();
            this.vatNumberControl.updateValueAndValidity({ emitEvent: false });
        }
    }

    IsValidationRequired(currentDocType: string, fieldConfigRes: any) {
        var required = fieldConfigRes.filter(x => x.name.includes(currentDocType))[0].required;
        if (required.toLowerCase() == 'optional') {
            return false;
        }

        if (required.toLowerCase() == 'yes') {
            return true;
        }

        return false;
    }

    CallAdditionalConfigurationService(supplierCode: string, entityCode: string, country: string, additionalFilter: QuestionFieldConfig[], clearValues: boolean, clearFederalTaxIdValue: boolean = false) {
        var configPropertiesVal = new SupplierConfigurationPropertiesPayload();
        configPropertiesVal.SupplierCode = supplierCode;
        configPropertiesVal.Country = country;
        configPropertiesVal.Category = SupplierConfigurationCategoryEnum.TAX;
        configPropertiesVal.Entity = entityCode;
        configPropertiesVal.AdditionalFilter = additionalFilter;

        this.store.dispatch(new IncrementLoaderCount());
        this.taxService.getAdditionalSupplierConfig(configPropertiesVal).subscribe(res => {

            // Add the documents list to the
            if (res.documentTypes?.length > 0) {
                this.additonalMandatoryDocs = res.documentTypes;
            
                if (this.configProperties?.documentTypes?.length > 0) {
                    // Remove Documents which are part of require documents and config properties
                    this.configProperties?.documentTypes.forEach(doc => {
                        this.requiredDocuments = this.requiredDocuments.filter(x => x.DocumentType != doc.name);
                    });
                }

                res.documentTypes.forEach(docType => {
                    const doc: OnboardingDocument = {
                        DocumentType: docType.name,
                        DocumentTypeDescription: docType.description,
                        Mode: "upload",
                        SignDateRequired: false,
                        SignedDate: null,
                        TypeID: docType.documentTypeID.toString(),
                        IsDocumentAvailableForSupplier : docType.isDocumentAvailableForSupplier,
                        AssociatedCategoryLinkId : docType.associatedCategoryLinkId,
                        IsOptional : docType.isOptional,
                        DocumentVersion : "1"
                    };

                    if (this.requiredDocuments?.some(x => x.DocumentType == doc.DocumentType) == false) {
                        this.requiredDocuments.push(doc);
                    }
                });
            }

            // Set Properties
            this.configProperties = res;

            this.setOptionalDocumentsInfo();

            // Set Tax Id Types
            if (this.configProperties?.taxIdTypes?.length > 0) {
                this.taxIDtypesByCountry = this.configProperties?.taxIdTypes;

                // Clear out tax id type if new tax id type is being changed
                if (!isNullOrUndefined(this.taxForm.get('TaxIDTypes')?.value)) {
                    if (this.taxIDtypesByCountry.some(x => x.taxIdType == this.taxForm.get('TaxIDTypes')?.value) == false) {
                        clearValues = true;
                    }
                }
            }
            else {
                this.taxIDtypesByCountry = [];
            }

            if(clearFederalTaxIdValue  || this.taxIdControl?.fieldValueExists == false)
            {
                if((this.taxIdTypeControl?.value != null && this.taxIdTypeControl?.value != undefined) && this.taxIDtypesByCountry?.find(x => x.taxIdType == this.taxIdTypeControl.value) != undefined)
                {
                      // no need to reset.
                }else
                {
                    this.taxIdTypeControl?.setValue(null);
                }
            }

            if(isNullOrUndefined(this.configProperties?.additionalTaxIdTypes) || this.configProperties?.additionalTaxIdTypes?.length <= 0)
            {
                this.additionalTaxIdTypesForm?.clearForm();
            }

            this.TaxIdTypeVerbiage = res.taxIdAdditionalTypeVerbiage;

            // Reset Tax Controls
            this.resetTaxIdControlV2(this.configProperties);

            // Reset Validators for Tax Id Control and Vat Number
            this.resetValidators(clearValues);
            this.store.dispatch(new DecrementLoaderCount());
        });
    }

    setOptionalDocumentsInfo() {
        if(this.configProperties?.optionalDocumentList?.length > 0)
        {
            this.OptionalDocuments = [];
            var optionalDocTypes = this.configProperties?.optionalDocumentList?.map(docType => {
                var docVal: DocumentTypeInfo = new DocumentTypeInfo();
                docVal.DocumentType = docType.name;
                docVal.DocumentTypeDescription = docType.description;
                docVal.DocumentTypeID = docType.documentTypeID;
                return docVal;
            });

            const docOptional: OnboardingDocument = {
                DocumentType: null,
                DocumentTypeDescription: null,
                Mode: "upload",
                SignDateRequired: false,
                SignedDate: null,
                TypeID: null,
                IsDocumentAvailableForSupplier : null,
                AssociatedCategoryLinkId : null,
                IsOptional : null,
                DocumentVersion : "1",
                IsOptionalList: true,
                DocumentTypeList: optionalDocTypes,
                ValidationRequired : true
            };

            if(this.supplierTax?.DocumentInfos?.length > 0 && this.supplierTax?.DocumentInfos.some(x => optionalDocTypes.map(x => x.DocumentType).includes(x.DocumentType) == true))
            {
                var currentDoc = this.supplierTax?.DocumentInfos.filter(x => optionalDocTypes.map(x => x.DocumentType).includes(x.DocumentType) == true)[0];
                docOptional.DocumentType = currentDoc?.DocumentType;
                docOptional.DocumentTypeDescription = currentDoc?.DocumentTypeDescription;
                docOptional.TypeID = currentDoc?.TypeID;
                docOptional.IsDocumentAvailableForSupplier = currentDoc?.IsDocumentAvailableForSupplier;
                docOptional.AssociatedCategoryLinkId = currentDoc?.AssociatedCategoryLinkId;    
                docOptional.IsOptional = currentDoc?.IsOptional;
                docOptional.SignDateRequired   = currentDoc?.SignDateRequired ?? false;
                docOptional.UploadedDate = currentDoc?.UploadedDate
                docOptional.SignedDate = currentDoc?.SignedDate;
                docOptional.FileName = currentDoc?.FileName;
                docOptional.DocumentID = currentDoc?.DocumentID;
                docOptional.File = currentDoc?.File;

                if(this.requiredDocuments.some(x => x.DocumentType == currentDoc?.DocumentType) == true)
                {
                    this.requiredDocuments = this.requiredDocuments.filter(x => x.DocumentType != currentDoc?.DocumentType);
                }
            }

            this.OptionalDocuments.push(docOptional);
            this.OptionalDocuments = _.cloneDeep(this.OptionalDocuments);
        }
        else
        {
            this.OptionalDocuments = [];
            this.OptionalDocuments = _.cloneDeep(this.OptionalDocuments);
        }
    }

    onTaxIdDataSaveEmitter(event: TaxIdTypeInfo[]) {
        if (event?.length > 0) {
            this.finalTaxIdTypeList = [];
            this.addtionalTaxIdTypeList = [];
            this.finalTaxIdTypeList = event;
        }
    }

    populateTaxIdListForm(taxIdInfoList: TaxIdTypeInfo[]) {
        this.configProperties.taxIdTypes = taxIdInfoList;
    }

    // On Corporate Question Change
    configureQuestionFieldConfig(fieldName: string, response: string) {
        //QA_Corporate_Ques
        const additionaFilter = new QuestionFieldConfig();
        additionaFilter.FieldName = fieldName;
        additionaFilter.Response = response;

        if (!isNullOrUndefined(response)) {
            this.CallAdditionalConfigurationService(this.supplierCode, null, this.selectedCountry?.abbreviation, [additionaFilter], false);
        }
    }

    resetErrorHighlight(controlName: string) {
        if (!isNullOrUndefined(this[controlName + '_Error'])) {
            if (!isNullOrUndefined(this[controlName + '_Control']?.value?.toString())) {
                this[controlName + '_Error'] = false;

                // Reset Values of checkbox to Null when the current value is false
                // This is required to make sure validation goes through
                if (this[controlName + '_Control']?.value == false) {
                    this[controlName + '_Control'].setValue(null);
                }
            }
        }
    }

    enableTaxIdTypeControl() {
        if (this.showExistingTaxID() == true) {
            this.editFederalTaxId();
        }
    }

    // This method is to process additional form data that needs to be passed for Dynmaic library
    AddAdditionalFormDataInfo(additionaFormDataInfo: AdditionalFormData[]) {
        if (!isNullOrUndefined(additionaFormDataInfo) && additionaFormDataInfo?.length > 0) {
            additionaFormDataInfo.forEach(formData => {
                if (!isNullOrUndefined(formData?.valuePath) && !isNullOrUndefined(this.formData)) {
                    // This logic indicates that the value needs to be provided from UI variables that are defined.
                    if (!isNullOrUndefined(this[formData.valuePath])) {
                        this.formData[formData?.key] = this[formData?.valuePath];
                        this.formData = _.cloneDeep(this.formData);

                        var processControl = (!isNullOrUndefined(formData?.processResponse) && formData?.processResponse == true) ? true : false;
                        if(processControl == false)
                        {
                            this.skippedControl.push(formData?.key);
                        }
                    }
                }
                this.skippedControl = this.skippedControl.filter((value, index, array) => array.indexOf(value) === index);

                if (!isNullOrUndefined(formData?.valueInfo)) {
                    this.ProcessFormDataValueInfo(formData);
                }

                this.formData = {...this.formData};
            });
        }
    }

    ProcessFormDataValueInfo(formData: AdditionalFormData) {
        // Process Value for formData where data type is string
        if (formData?.valueInfo.type == FormDataDataType.STRING) {
            // If Additional Value is available process the data accordinly
            if (!isNullOrUndefined(formData?.valueInfo?.additionalInfo) && formData?.valueInfo?.additionalInfo?.length > 0 && !isNullOrUndefined(this.formData)) {
                var currentValueInfo = formData?.valueInfo?.value;
                formData?.valueInfo?.additionalInfo.forEach(info => {
                    var currentValue = info?.value;

                    // if translation is required we will need to translate the value
                    if (formData?.isTranslationNeeded == true) {
                        currentValue = this.translate.get(info?.value);
                    }

                    // Once the tranlation is done we will replace the Key in the final string
                    var currentKey = '{{' + info.key + '}}';
                    currentValueInfo = formData?.valueInfo?.value?.replace(currentKey, currentValue);
                });

                this.formData[formData?.key] = currentValueInfo;
                var processControl = (!isNullOrUndefined(formData?.processResponse) && formData?.processResponse == true) ? true : false;
                if(processControl == false)
                {
                    this.skippedControl.push(formData?.key);
                }
            }

            if (isNullOrUndefined(formData?.valueInfo?.additionalInfo) && !isNullOrUndefined(this.formData)) {
                var currentValue = formData?.valueInfo?.value;

                // if translation is required we will need to translate the value
                if (formData?.isTranslationNeeded == true) {
                    currentValue = this.translate.get(formData?.valueInfo?.value);
                }

                this.formData[formData?.key] = currentValue;
                var processControl = (!isNullOrUndefined(formData?.processResponse) && formData?.processResponse == true) ? true : false;
                if(processControl == false)
                {
                    this.skippedControl.push(formData?.key);
                }
            }
        }
    }

    CreateDynmaicWithHoldingResponse(): WithHoldingResponse[] {
        let currentDynamicFormData: any = { ...this.withHoldingForm?.listToObject() }
        var finalWithHoldingResponseData: WithHoldingResponse[] = [];

        // Get the current keys
        if (!isNullOrUndefined(currentDynamicFormData)) {
            var currentKeys = Object.keys(currentDynamicFormData);

            // Loop over each key and update the
            currentKeys?.forEach(key => {

                // if the value is populated than create the respective withholding response
                if ((!isNullOrUndefined(this.skippedControl) && this.skippedControl?.includes(key) == false) && !isNullOrUndefined(currentDynamicFormData[key]) && currentDynamicFormData[key]?.length > 0) {
                    var currentCountry = key.substring(0, 2).toUpperCase();

                    if (finalWithHoldingResponseData.filter(x => x.CountryCode == currentCountry)?.length > 0) {
                        // Add the withholding questionaire response
                        var withHoldingQuestion = new WithHoldingQuestionResponse();
                        withHoldingQuestion.QuestionIdentifier = key;
                        withHoldingQuestion.QuestionResponse = currentDynamicFormData[key];
                        finalWithHoldingResponseData?.filter(x => x.CountryCode == currentCountry)[0]?.WithHoldingQuestionResponse?.push(withHoldingQuestion);
                    }
                    else {
                        var resp = new WithHoldingResponse();
                        resp.CountryCode = currentCountry;

                        // Add the withholding questionaire response
                        var withHoldingQuestion = new WithHoldingQuestionResponse();
                        withHoldingQuestion.QuestionIdentifier = key;
                        withHoldingQuestion.QuestionResponse = currentDynamicFormData[key];
                        resp.WithHoldingQuestionResponse = [];
                        resp?.WithHoldingQuestionResponse?.push(withHoldingQuestion);

                        // Push the withholding form response to final response
                        finalWithHoldingResponseData.push(resp);
                    }
                }
            });
            return finalWithHoldingResponseData;
        }

        return null;
    }

    // Addition Translation Changes for Dynamic Form
    initTranslation() {
        this.destroyed$.next(true);
        this.translocoService.langChanges$.subscribe((res) => {
            if (_.isEmpty(this.translocoService.getTranslation(res))) {
                this.subscription = this.translocoService.events$
                    .pipe(
                        filter((e) => e.type === 'translationLoadSuccess'),
                        takeUntil(this.destroyed$),
                    )
                    .subscribe((obj) => {
                        this.updateLocale(res);
                    });
            } else {
                this.updateLocale(res);
            }
        });
    }

    updateLocale(newLanguage) {
        const newFile = this.translocoService.getTranslation(newLanguage);
        if (!newFile) {
            return;
        }
        this.file = newFile;
    }

    // On Change Event function for WithHolding form
    onWithHoldingFormFieldChangeEvent(event) {
        this.isWithHoldingFormModified = true;
        if(!isNullOrUndefined(this.evalfuncList) && this.evalfuncList?.length > 0 && !isNullOrUndefined(this.withHoldingForm))
        {
            this.evalfuncList.forEach(x => {
                eval(x)(event, this.withHoldingForm , this.formSchema);
            });
        }

        if(this.formDataConfigurationList?.length > 0 && !isNullOrUndefined(event?.field?.key) && this.formDataConfigurationList?.includes(event?.field?.key))
        {
            //QA_Corporate_Ques
            const additonalFilterList = [];

            let currentDynamicFormData: any = { ...this.withHoldingForm?.listToObject() }

            if(!isNullOrUndefined(currentDynamicFormData))
            {
                this.formDataConfigurationList.forEach(x => {
                    const additionaFilter = new QuestionFieldConfig();
                    additionaFilter.FieldName = x;
                    additionaFilter.Response =  (x == event?.field?.key) 
                                                    ? event?.formControl?.value 
                                                    : (!isNullOrUndefined(currentDynamicFormData[x]) && currentDynamicFormData[x] != '') 
                                                                                    ? currentDynamicFormData[x]
                                                                                    : '';
                    additonalFilterList.push(additionaFilter);
                });
            }

            if (!isNullOrUndefined(additonalFilterList?.length > 0)) {
                var clearFederalTaxIdValue = this.taxIdControl?.fieldValueExists;
                this.CallAdditionalConfigurationService(this.supplierCode, null, this.selectedCountry?.abbreviation, additonalFilterList, false, clearFederalTaxIdValue);
            }
        }
    }

    UpdateSchemaOnPreloadedEvent(withHoldingFormSchema: any)
    {
        if(!isNullOrUndefined(this.formData))
        {
            // Consolidate all formdata info
            var currentKeys = Object.keys(this.formData);
            var eventList = [];
            const additonalFilterList = [];
            currentKeys.forEach(eventInfoVal => {
                eventList.push({
                    field : {
                    key : eventInfoVal
                    },
                    value :this.formData[eventInfoVal]
                })

                if(this.formDataConfigurationList?.includes(eventInfoVal))
                {
                    const additionaFilter = new QuestionFieldConfig();
                    additionaFilter.FieldName = eventInfoVal;
                    additionaFilter.Response =  this.formData[eventInfoVal];
                    additonalFilterList.push(additionaFilter);
                }
                
            });

            if(eventList?.length > 0)
            {
                eventList?.forEach(event => {
                    this.evalfuncList.forEach(x => {
                    eval(x)(event, this.withHoldingForm, this.formSchema);
                    });
                });
            }

            if(additonalFilterList?.length > 0)
            {
                this.CallAdditionalConfigurationService(this.supplierCode, null, this.selectedCountry?.abbreviation, additonalFilterList, false);
            }
        }

        return this.formSchema;
    }

  updateSchema(withHoldingFormSchema:any , fieldName, values) {
    withHoldingFormSchema?.formBody?.forEach((section) =>
      section?.fields?.forEach((field: IField, index) => {
          if (field.key === fieldName) {
            var tempValues = {...values};
            if (values?.props && field.props) {
                section.fields[index].props = { ...field?.props, ...values?.props };
                delete tempValues?.props;
            }
            section.fields[index] = { ...field, ...tempValues };
          }
      })
    );
  }

  accordianViewChange(event: any , expandEvent: any)
  {
    if(this.isToggleSelected == false)
    {
      this.accordion?.openAll();
      this.isToggleSelected = true;
      this.actionName = 'Collapse All';
    }
    else
    {
      this.accordion?.closeAll();
      this.isToggleSelected = false;
      this.actionName = 'Expand All';
    }
  }

  onExpansionChange(event: any)
  {
    this.accordianViewChange(null, event);
  }

  callOnboaringTaxDocuments(country: string)
  {
    if (country && this.taxDocuments && this.taxDocuments.length >= 1) {
        // re-calculate required documents based on field config against entity, country only for onboarding
        this.taxService.getOnboardingTaxdocument(this.supplierCode, country).subscribe(res => {
            if (res && res.length >= 1) {
                this.onboardingTaxDocuments = res;
                let result = res.filter(y => (y.required.toLowerCase() == "yes"))?.map(x => x.name);
                let docsRequired = this.taxDocuments.filter(x => result?.includes(x.name));

                // Update Associated Tax Info Id values if available
                docsRequired.forEach(x => {
                    var resDoc = res.filter(y => y.name == x.name)[0];
                    x.associatedCategoryLinkId = resDoc.associatedCategoryLinkId;
                    x.isDocumentAvailableForSupplier = resDoc.isDocumentAvailableForSupplier;
                });

                if (docsRequired) {
                    if (!this.requiredDocuments || (this.requiredDocuments?.length == 0) || (this.OptionalDocuments?.length > 0 && this.requiredDocuments?.findIndex(x => x?.IsOptionalList == false)) || this.requiredDocuments?.findIndex(x => docsRequired.map(y => y.name).includes(x.DocumentType)) == -1) {
                        this.requiredDocuments = [];
                        docsRequired.forEach(doc => {
                            var document: OnboardingDocument = {
                                DocumentType: doc.name,
                                DocumentTypeDescription: doc.description,
                                Mode: "upload",
                                SignDateRequired: false,
                                TypeID: doc.documentTypeID.toString(),
                                IsDocumentAvailableForSupplier: doc.isDocumentAvailableForSupplier,
                                AssociatedCategoryLinkId: doc.associatedCategoryLinkId,
                            }
                            this.requiredDocuments.push(document);
                        });
                    }
                    else {
                        this.requiredDocuments = this.requiredDocuments.filter(x => docsRequired.map(y => y.name).includes(x.DocumentType))
                        this.requiredDocuments.forEach(x =>
                        {
                            var currentResDoc = res.find(docVal => docVal.name == x.DocumentType);
                            x.IsDocumentAvailableForSupplier = currentResDoc.isDocumentAvailableForSupplier;
                            x.AssociatedCategoryLinkId = currentResDoc.associatedCategoryLinkId;
                        });
                    }
                }

                if (!isNullOrUndefined(this.supplierTax) && this.supplierTax?.DocumentInfos?.length > 0) {
                    if (this.requiredDocuments?.some(x => x.DocumentType == x.DocumentType) == false) {
                        this.supplierTax?.DocumentInfos?.forEach(x => 
                        {
                            if(res.some(resDoc => resDoc.name == x.DocumentType) == true)
                            {
                                var currentResDoc = res.find(resDoc => resDoc.name == x.DocumentType);
                                x.IsDocumentAvailableForSupplier = currentResDoc.isDocumentAvailableForSupplier;
                                x.AssociatedCategoryLinkId = currentResDoc.associatedCategoryLinkId;
                            }

                            this.requiredDocuments.push(x);
                        });
                    }
                }

                this.setOptionalDocumentsInfo()

                if (this.configProperties?.documentTypes?.length > 0) {
                    // Add latest additional documents types
                    if (this.configProperties?.documentTypes?.length > 0 && this.additonalMandatoryDocs?.length > 0) {
                        let isArrayEqual = true;
                        if (this.configProperties?.documentTypes?.length == this.additonalMandatoryDocs?.length) {
                            this.configProperties?.documentTypes.forEach(doc => {
                                if (this.additonalMandatoryDocs.some(x => x.name == doc.name) == false) {
                                    isArrayEqual = false;
                                }
                            });
                        }

                        if (isArrayEqual = false) {
                            // Remove Documents which are part of require documents and config properties
                            this.configProperties?.documentTypes.forEach(doc => {
                                this.requiredDocuments = this.requiredDocuments.filter(x => x.DocumentType != doc.name);
                            });
                        }
                    }

                    this.additonalMandatoryDocs.forEach(x => {

                        var existingDoc = this.supplierTax?.DocumentInfos?.find(y => y.DocumentType == x.name);
                        let docVal: OnboardingDocument = {
                            DocumentType: x.name,
                            DocumentTypeDescription: x.description,
                            Mode: "upload",
                            SignDateRequired: false,
                            IsOptional: x.isOptional,
                            TypeID: x.documentTypeID.toString(),
                            IsDocumentAvailableForSupplier : x.isDocumentAvailableForSupplier,
                            AssociatedCategoryLinkId : x.associatedCategoryLinkId,
                            FileName: existingDoc?.FileName ?? null,
                            FileNameGuid: existingDoc?.FileNameGuid ?? null,
                            DocumentID: existingDoc?.DocumentID ?? null,
                            SignedDate: existingDoc?.SignedDate ?? null,
                            UploadedDate : existingDoc?.UploadedDate ?? null,
                            DocumentVersion: existingDoc?.DocumentVersion ?? null,
                        }

                        if (this.requiredDocuments.some(x => x.DocumentType == docVal.DocumentType) == false) {
                            this.requiredDocuments.push(docVal);
                        }
                    })
                }
            }
            else
            {
                this.onboardingTaxDocuments = [];
            }
        })
    }
  }
}